// @ts-nocheck
import React from "react"
import "../../css/poc-report-style.css"
import { displayUtcToUserTimezone, getIntFromString, ReactMarkdown, TextField } from "modules/look"
import { Button, Modal, Spin, Table, Tooltip } from "antd"
import { dashboard_home_icons, organization_icons } from "modules/poc-dashboard/icons"
import styled from "styled-components"
import { Bar } from "react-chartjs-2"
import { SURVEY_WHOLE_IDENTITY, EFFECTIVE_WORK_COMMUNICATION } from "../../../../config"
import am_dashboard_routes from "modules/poc-dashboard/account-manager/routes"
const PocUserReportView = (props) => {
    const {
        ui_flow_type,
        list,
        header_list,
        loading,
        basic_detail,
        navigateRoute,
        getToolById,
        downloadCSV,
        match,
        updateGrades,
        location
    } = props

    const [ReportList, setReportList] = React.useState([]);
    const [selectedQuestion, setSelectedQuestion] = React.useState({
        showModal: false,
        selectedQuestion: [],
        initialGrades: {},
        updatedGrades: {}
    })
    const [invalidGrade, setInvalidGrade] = React.useState([])
    React.useEffect(() => {
        if (getToolById) {

            if (getToolById?.self?.length) {
                let report = getToolById
                let selfList = getToolById?.self
                selfList.forEach(element => {
                    element['overAll'] = report?.overall.filter(item => element?.answer__question__group__id === item?.answer__question__group__id)
                    element['respondents'] = report?.respondents.filter(item => element?.answer__question__group__id === item?.answer__question__group__id)
                });
                setReportList(selfList)
            }
        }
    }, [getToolById])


    const ToDecimal = (value) => {
        if (value % 1) {
            return value.toFixed(1)
        }
        else {
            return value
        }
    }
    const chartData = (chart) => {

        let Values = []
        let labels = []
        let dataSource = []
        const columns = [
            {
                title: <Tooltip title="Type of Respondent">TYPE</Tooltip>,
                key: 'TYPE',
                render: (text, record) => record &&
                    <Tooltip title={record?.type}>
                        <p style={{ maxWidth: '100px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', marginTop: '5px' }}>{record?.type}</p>
                    </Tooltip>
            },
            {
                title: <Tooltip title="Average">AVG</Tooltip>,
                key: 'AVG',
                render: (text, record) => record &&
                    <p style={{ marginTop: '5px' }}>{record?.AVG}</p>
            },
            {
                title: <Tooltip title="Standard Deviation">SD</Tooltip>,
                key: 'SD',
                render: (text, record) => record &&
                    <p style={{ marginTop: '5px' }}>{record?.SD}</p>
            },

            {
                title: <Tooltip title="High">HI</Tooltip>,
                key: 'HI',
                render: (text, record) => record &&
                    <p style={{ marginTop: '5px' }}>{record?.HI}</p>
            },
            {
                title: <Tooltip title="Low">LO</Tooltip>,
                key: 'LO',
                render: (text, record) => record &&
                    <p style={{ marginTop: '5px' }}>{record?.LO}</p>
            }
        ]
        if (chart?.overAll?.length) {
            labels.push('OverAll')
            const Avg = chart?.overAll.reduce((a, b) => a + b?.Avg_response, 0)
            Values.push(Avg)
            let tableOverall = {
                type: 'OverAll',
                AVG: ToDecimal(Avg),
                SD: ToDecimal(chart?.overAll.reduce((a, b) => a + b?.StdDev_response, 0)),
                HI: ToDecimal(chart?.overAll.reduce((a, b) => a + b?.Max_response, 0)),
                LO: ToDecimal(chart?.overAll.reduce((a, b) => a + b?.Min_response, 0)),
            }
            dataSource.push(tableOverall)
        }

        if (chart?.respondents?.length) {

            chart.respondents.forEach(element => {
                const Avg = element?.Avg_response
                labels.push(element?.respondentType)
                Values.push(Avg)
                let tablerespondents = {
                    type: element?.respondentType,
                    AVG: ToDecimal(Avg),
                    SD: ToDecimal(element.StdDev_response),
                    HI: ToDecimal(element?.Max_response),
                    LO: ToDecimal(element.Min_response),
                }
                dataSource.push(tablerespondents)
            });
        }



        labels.push('Self')
        Values.push(chart?.Avg_response)
        let tableSelf = {
            type: 'Self',
            AVG: ToDecimal(chart?.Avg_response),
            SD: ToDecimal(chart?.StdDev_response),
            HI: ToDecimal(chart?.Max_response),
            LO: ToDecimal(chart?.Min_response),
        }
        dataSource.push(tableSelf)
        const chartData = {
            labels: labels,
            datasets: [{
                data: Values,
                backgroundColor: "rgba(76, 203, 31, 1)",
                borderColor: "rgba(76, 203, 31, 1)",

            }]
        };
        let maxValue = ((parseInt(Math.max(...Values) / 10) + 1) * 10)

        const options = {
            responsive: true,
            scales: {
                x: {
                    min: 0,
                    max: maxValue > 100 ? maxValue : 100
                }
            },
            indexAxis: 'y',
            elements: {
                bar: {
                    borderWidth: 1,
                    borderHeight: 1
                },
            },
            plugins: {
                legend: {
                    position: 'bottom',
                    display: false
                },
                title: {
                    display: false,
                }
            },
        };
        return (
            <>
                <div className='report-chart-table-container'>
                    <div className='report-grap-container'>
                        <Bar data={chartData} options={options} height={dataSource?.length * 30} />
                    </div>
                    <div className='report-table-container'>
                        <MyTable
                            size={'middle'}
                            loading={loading}
                            showHeader={true}
                            pagination={false}
                            style={{ width: "100%" }}
                            dataSource={
                                dataSource
                                    ? dataSource
                                    : []
                            }
                            columns={columns.map(c => ({ ...c, sortDirections: ['descend', 'ascend', 'descend'] }))}

                        />
                    </div>

                </div>

            </>
        )
    }

    const handleOk = () => {
        let answers = [{
            gradingParametersAnswers: selectedQuestion.updatedGrades,
            answer: selectedQuestion?.answer,
            questionId: getIntFromString(selectedQuestion?.questionId)
        }]
        let respId = match?.params?.response_id
        updateGrades(answers, respId)
        setSelectedQuestion({
            showModal: false,
            selectedQuestion: [],
            initialGrades: {},
            updatedGrades: {}
        })
    }

    const handleCancel = () => {
        setSelectedQuestion({
            showModal: false,
            selectedQuestion: [],
            initialGrades: {},
            updatedGrades: {}
        })
    }
    const getTotalGrades = () => {
        try {
            if (selectedQuestion?.selectedQuestion) {
                const maxGrades = selectedQuestion.selectedQuestion.filter(ele => ele?.key === "View/Edit Grades")?.[0]?.max_score
                if (maxGrades) {
                    if (Object.values(maxGrades))
                        return Object.values(maxGrades).reduce((ele, acc) => acc += Number(ele))
                    else
                        return 1
                } else {
                    return 1
                }
            } else {
                return 1
            }
        } catch (error) {
            return 1
        }
    }

    const getRecievedGrades = () => {
        try {
            if (selectedQuestion?.updatedGrades) {
                if (Object.values(selectedQuestion.updatedGrades).length)
                    return Object.values(selectedQuestion.updatedGrades).reduce((ele, acc) => acc += Number(ele))
                else
                    return 0
            } else
                return 0
        } catch (error) {
            return 0
        }
    }

    const getMaxScore = (param) => {
        try {
            if (selectedQuestion?.selectedQuestion) {
                const maxGrades = selectedQuestion.selectedQuestion.filter(ele => ele?.key === "View/Edit Grades")?.[0]?.max_score
                if (maxGrades) {
                    if (maxGrades[param])
                        return maxGrades[param]
                    else
                        return 1
                } else {
                    return 1
                }
            } else {
                return 1
            }
        } catch (error) {
            return 1
        }
    }

    const handleValidationArr = (value, index) => {
        if (invalidGrade[index] !== value) {
            let arrayCopy = [...invalidGrade]
            arrayCopy[index] = value;
            setInvalidGrade(prev => arrayCopy)
        }
    }

    const getValidationClass = (updatedGrade, param, index) => {
        try {
            if (selectedQuestion?.selectedQuestion) {
                const maxGrades = selectedQuestion.selectedQuestion.filter(ele => ele?.key === "View/Edit Grades")?.[0]?.max_score
                if (maxGrades) {
                    if (maxGrades[param]) {
                        if (Number(updatedGrade) < 0 || Number(updatedGrade) > maxGrades[param])
                            handleValidationArr(true, index)
                        else
                            handleValidationArr(false, index)
                        return Number(updatedGrade) < 0 || Number(updatedGrade) > maxGrades[param] ? "invalid-input" : ""
                    } else {
                        handleValidationArr(false, index)
                        return ""
                    }
                } else {
                    handleValidationArr(false, index)
                    return ""
                }
            } else {
                handleValidationArr(false, index)
                return ""
            }
        } catch (error) {
            handleValidationArr(false, index)
            return ""
        }
    }

    return (
        <>
            <Modal
                title="Dashboard Modal"
                className="grade-edit-modal"
                visible={selectedQuestion.showModal}
                open={selectedQuestion.showModal}
                onOk={handleOk}
                onCancel={handleCancel}
                centered
                width={"70%"}
                footer={
                    <div style={{ display: 'flex', justifyContent: 'space-between', gap: '8px' }}>
                        <div className="score">Score: {getRecievedGrades()}/{getTotalGrades()}</div>
                        <div className="validation-msg"></div>
                        <div className="modal-actions">
                            <Button onClick={handleCancel}>Cancel</Button>
                            <Button type="primary" onClick={handleOk} disabled={(() => invalidGrade.some(ele => ele))()}>Save Grades</Button>
                        </div>
                    </div>
                }
            >
                <div className="modal-container">
                    <div className="question-section">
                        <ReactMarkdown>
                            {
                                selectedQuestion.selectedQuestion?.filter(ele => ele?.key === "Question")?.[0]?.value
                            }
                        </ReactMarkdown>
                    </div>
                    <div className="answer-section">
                        <div className="answer-preview">
                            <ReactMarkdown>
                                {
                                    selectedQuestion.selectedQuestion?.filter(ele => ele?.key === "Answer")?.[0]?.value
                                }
                            </ReactMarkdown>
                        </div>
                        <div className="greading-view">
                            {
                                (() => {
                                    const value = selectedQuestion.selectedQuestion?.find(ele => ele?.key === "View/Edit Grades")?.value;
                                    return value
                                        ? <div className="grade-container">
                                            {
                                                ((value) => {
                                                    const gradeUnsorted = JSON.parse(value);
                                                    const grades = Object.keys(gradeUnsorted)
                                                        .sort()
                                                        .reduce((acc, key) => {
                                                            acc[key] = gradeUnsorted[key];
                                                            return acc;
                                                        }, {});
                                                    if (JSON.stringify(selectedQuestion.initialGrades) !== JSON.stringify(grades)) {
                                                        setSelectedQuestion(prevState => ({
                                                            ...prevState,
                                                            initialGrades: grades,
                                                            updatedGrades: grades
                                                        }))
                                                    }
                                                    return (
                                                        Object.entries(grades).map(([param, grade], index) =>
                                                            <div className="grade-row" style={{ display: "flex" }}>
                                                                <TextField
                                                                    name="grade-input"
                                                                    className={`edit-grade-input-field ${getValidationClass(selectedQuestion.updatedGrades[param], param, index)}`}
                                                                    label={Object.keys(grades).length === 1 ? "Grades:" : `Grades for ${param.replace(/^.*?_/, '')}:`}
                                                                    offset={2}
                                                                    value={selectedQuestion.updatedGrades[param]}
                                                                    type="number"
                                                                    gradeInput={true}
                                                                    onChange={e => {
                                                                        const { value } = e.target;
                                                                        setSelectedQuestion({
                                                                            ...selectedQuestion,
                                                                            updatedGrades: {
                                                                                ...selectedQuestion.updatedGrades,
                                                                                [param]: value ? Number(value) : null
                                                                            }
                                                                        })
                                                                    }}
                                                                />
                                                                <div className="max-grade">/ {getMaxScore(param)}</div>
                                                            </div>
                                                        )
                                                    )

                                                })(value)
                                            }
                                        </div>
                                        : null;
                                })()
                            }
                        </div>
                    </div>
                </div>
            </Modal>

            {loading ?
                <div style={{ width: "100%", height: "50vh", display: "flex", justifyContent: "center", alignItems: "center" }}>
                    <Spin spinning={loading}> </Spin>
                </div>
                :

                basic_detail && (
                    <>
                        <div style={{ display: "flex", flexDirection: "row", justifyContent: "start", gap: "1em", alignItems: "center" }}>
                            <img src={organization_icons?.back_arrow} alt="back_arrow" style={{ width: "25px", cursor: "pointer" }} onClick={() => navigateRoute("-1")} />
                            <h4 className="poc-dashboard-card-title" style={{ fontWeight: "600" }}>Report for {basic_detail?.survey_name}</h4>
                        </div>
                        <div className="poc-survey-report-root">
                            <div className="space-between-row">
                                <div>
                                    <h4 className="poc-dashboard-card-title" style={{ fontWeight: "600" }}><span className="text-transform-capitalize">{basic_detail?.user?.firstName}</span> <span className="text-transform-capitalize">{basic_detail?.user?.lastName || ""}</span></h4>
                                    <h4 className="poc-dashboard-card-title" style={{ fontWeight: "400", color: "rgba(137, 152, 162, 1)", fontSize: ".75em" }}>Date : {displayUtcToUserTimezone(basic_detail?.response_date, 'DD/MM/YYYY')}</h4>
                                </div>
                                {
                                    <div style={{ display: "flex", flexDirection: "row", gap: "0.5em", justifyContent: "center", alignItems: "center" }}>
                                        {
                                            (ui_flow_type === "EXPECTED_ANSWER" || ui_flow_type === "NORMAL_ANSWER") && (
                                                <Button className="export-btn" onClick={() => downloadCSV()}><img src={dashboard_home_icons?.export_icon} alt="export_icon" style={{ height: "1.25em", marginRight: "1em" }} /> Export</Button>
                                            )
                                        }

                                        {basic_detail?.show_score && (
                                            <h4 className="poc-dashboard-card-title">Total Score : <span style={{ color: basic_detail?.total_score <= 7 ? "red" : "#31D0AA" }}>{basic_detail?.total_score}/{basic_detail?.max_score}</span></h4>
                                        )}

                                    </div>

                                }
                            </div>
                            {
                                (ui_flow_type === "EXPECTED_ANSWER" || ui_flow_type === "NORMAL_ANSWER") && (
                                    <div className={`org-table-container poc_table_scroll module-usage-table-height`} >
                                        <table className='org-table'>
                                            <thead>
                                                <tr className='org-row-header'>
                                                    {
                                                        header_list?.map((i, index) => (
                                                            <th className={`org-table-header-label ${index === 0 ? "org-left-radious" : ""} ${index === (header_list?.length - 1) ? "org-right-radious" : ""}`} style={{ textAlign: index === 0 ? "left" : "center", ...i?.custom_style }}>
                                                                <h4 className='org-table-header-label'>{i?.label}</h4>
                                                            </th>
                                                        ))
                                                    }
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {list?.map(item => (
                                                    <tr className='org-row-body'>
                                                        {
                                                            item?.map((i, index) => (
                                                                <td className={`${(index !== 0 && index !== (header_list?.length - 1)) ? "table-border-up-down" : ""} ${index === 0 ? "org-left-radious table-border-left" : ""} ${index === (header_list?.length - 1) ? "org-right-radious table-border-right" : ""}`} style={{ textAlign: "center" }}  >
                                                                    {
                                                                        i?.type === "label" && (
                                                                            <h4
                                                                                className='org-table-body-label'
                                                                                style={{
                                                                                    fontWeight: '500',
                                                                                    wordBreak: 'break-word',
                                                                                    textAlign: i?.key === "Question" || i?.key === "Answer"
                                                                                        ? "start"
                                                                                        : "center"
                                                                                }}>
                                                                                {
                                                                                    !EFFECTIVE_WORK_COMMUNICATION.includes(Number(match?.params?.survey_id || "-1"))
                                                                                        ? i?.value
                                                                                        : <ReactMarkdown>{i?.value}</ReactMarkdown>
                                                                                }
                                                                            </h4>
                                                                        )
                                                                    }{
                                                                        i?.type === "action" && i?.value && Object.values(am_dashboard_routes).some(routes => location?.pathname.includes(routes)) && (
                                                                            <img
                                                                                src={dashboard_home_icons?.edit_report}
                                                                                alt="report_icon"
                                                                                style={{ cursor: "pointer", width: "30px" }}
                                                                                onClick={() => {
                                                                                    setSelectedQuestion({
                                                                                        ...selectedQuestion,
                                                                                        showModal: true,
                                                                                        selectedQuestion: item,
                                                                                        answer: item.filter(ele => ele.key === "Answer")[0].value,
                                                                                        questionId: i?.questionId
                                                                                    })
                                                                                }}
                                                                            />
                                                                        )
                                                                    }
                                                                </td>
                                                            ))
                                                        }
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>

                                        {
                                            (!list?.length && !loading) ?
                                                <div style={{ width: "100%", height: "5em" }}>
                                                    <h4 className='rd-nodata-label' style={{ textAlign: "center" }}>No data found</h4>
                                                </div> : ''
                                        }
                                    </div>
                                )
                            }
                            {
                                (ui_flow_type === "REPORT_TOOL" && getToolById) && (
                                    <div style={{ width: "100%", marginTop: "2em" }}>
                                        {
                                            Number(match?.params?.survey_id) !== SURVEY_WHOLE_IDENTITY ?

                                                <div>
                                                    {ReportList?.length ?
                                                        <div >

                                                            {
                                                                ReportList.map(chart =>
                                                                    // <div className="assesment-card">
                                                                    <div className="assesment-card">
                                                                        <div className='assessment-report-container'>
                                                                            <div className='assessment-report-text-container' style={{ width: "50%" }}>
                                                                                <h4 className="poc-dashboard-card-title" style={{ fontWeight: "normal", fontSize: "1.25em" }}><ReactMarkdown>{chart?.answer__question__group__label}</ReactMarkdown></h4>
                                                                                <h4 className="poc-dashboard-card-title" style={{ fontWeight: "400", fontSize: "1em", whiteSpace: "wrap" }}><ReactMarkdown>{chart?.answer__question__group__help_text}</ReactMarkdown></h4>
                                                                            </div>
                                                                            <div style={{ width: "fit-content" }}>
                                                                                {chartData(chart)}
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    // </div>
                                                                )
                                                            }

                                                        </div>
                                                        :
                                                        !loading && <h3 style={{ textAlign: 'center', marginTop: '200px' }}>NO 360 REPORTS FOUND</h3>
                                                    }
                                                </div>
                                                :
                                                getToolById?.includes("Whole") ?
                                                    <ReactMarkdown>{JSON.parse(getToolById)}</ReactMarkdown>
                                                    : <h3 style={{ textAlign: 'center', marginTop: '200px' }}>NO 360 REPORTS FOUND</h3>
                                        }

                                    </div>
                                )
                            }

                        </div>
                    </>
                )}

        </>
    )

}

export default PocUserReportView


export const MyTable = styled(Table)`
  table {
    border-collapse: collapse !important;
    th{
        text-align:center !important;
         border: 1px solid rgba(170, 186, 198, 1)!important;
        font-weight:600;
        font-family:Poppins,
        font-size:1em;
        padding-bottom:5px !important;
        background:#fff !important;
    }
    tbody {
            border: 1px solid rgba(170, 186, 198, 1)!important;
            background: rgba(213, 229, 242, 0.2);
        tr{
        border: 1px solid rgba(170, 186, 198, 1)!important;
        border-style: solid none !important;
        }
      td{
        font-size:1em;
        text-align:center !important;
        font-weight:400;
        font-family:Poppins;
        border: 1px solid rgba(170, 186, 198, 1)!important;
      } 
    p{
    margin:0px !important;
    }
    .ant-table-cell {
    padding: 5px 10px !important;

  }
`;
